/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'star': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M36.906 21h-9.438l-2.922-9-2.971 9H12l7.757 5.455-2.913 8.862 7.648-5.564 7.679 5.508-2.909-8.85L36.906 21z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/star.js